import stampit from 'stampit';
import angular from 'angular';
import _ from 'lodash';
import { TokboxStreamErrorHandler } from './../providers/video/tokbox/tokbox-stream-error-handler/tokbox-stream-error-handler';
import { isGoodAudio, isPoorVideo, } from '../providers/video/common/lib/doxyme-opentok-mos';
import { EndCallReasons } from '../common/services/doxy-analytics/tracks/video-session-end';
import { AudioTypes, MediaModes, } from '../providers/video/abstract-video-provider';
import { RootScopeEvents } from '../common/services/root-scope-types';
import { selectLocationDetails } from '../store/features/system';
import { constants as notificationConstants } from '../modules/notifications';
import { extensionIntegrEvents } from '../modules/extensions-framework/angular-integration/integration-types';
import { VideoProviderEvents } from '../providers/video';
import * as dokbot from '../modules/dokbot';
import { GrowthBookFeatures, hasGrowthBookFeature } from '../modules/core';
export var VideoChatRealtimeMessageTypes;
(function (VideoChatRealtimeMessageTypes) {
    VideoChatRealtimeMessageTypes["INIT"] = "init";
    VideoChatRealtimeMessageTypes["CHANGE_VIDEO_QUALITY"] = "change-video-quality";
    VideoChatRealtimeMessageTypes["CHANGE_AUDIO_TYPE"] = "change-audio-type";
    VideoChatRealtimeMessageTypes["CAPTIONS_TOGGLE"] = "captions-toggle";
})(VideoChatRealtimeMessageTypes || (VideoChatRealtimeMessageTypes = {}));
export var CallNotifications;
(function (CallNotifications) {
    CallNotifications["Hold"] = "hold";
})(CallNotifications || (CallNotifications = {}));
export default angular
    .module('doxy.realtime.components.phone', [])
    .run((VideoProviderFactory, $rootScope) => {
    new TokboxStreamErrorHandler($rootScope, VideoProviderFactory).start();
})
    .factory('VideoChatRealtimeComponent', function (RealtimeComponent, notificationFactory, pn, Browser, globalUi, $q, Room, $rootScope, $modal, notifications, $log, VideoProviderFactory, activeStreamService, $timeout, callQualitySurveyService, DokbotPatientSurveyService, downgradeCallStateService, currentUserHelper, CallSession, videoFreezeDetector, $ngRedux) {
    const debug = $log.debug.bind($log, 'video-chat:');
    function shouldStopVideo() {
        const amIDoctor = pn.isDoctor();
        return (!(amIDoctor &&
            VideoProviderFactory.activeProvider.peopleCollection.length) &&
            !VideoProviderFactory.activeProvider.peopleCollection.getDoctors()
                .length);
    }
    function _setStateOnVideoStart() {
        const activeVideoProvider = VideoProviderFactory.activeProvider;
        activeVideoProvider.removeSessionEvents();
        callQualitySurveyService.hide();
        const { hasCamera, onlyChat } = pn.globalState;
        activeVideoProvider.updateState({
            hasCamera,
            onlyChat,
        });
        activeStreamService.init();
        videoFreezeDetector.init();
        activeVideoProvider.on(VideoProviderEvents.ConnectionCreated, ({ person }) => {
            if (pn.isDoctor() && !person.waitTimeSaved) {
                trackWaitTime(this, person);
            }
            ensureMediaOptionsApplied(this.options);
            $rootScope.$emit('phone:join', person);
            if (Boolean(activeVideoProvider.isInGroupCall)) {
                $rootScope.$emit(extensionIntegrEvents.ADD_PERSON_TO_GROUP_CALL, person);
            }
        });
        const autoDowngradeQuality = !!(this.options && this.options.autoDowngradeQuality);
        downgradeCallStateService.resetState(autoDowngradeQuality);
        if (!(this.options && this.options.audioOnly) && autoDowngradeQuality) {
            let downgradeTimestamp;
            activeVideoProvider.on(VideoProviderEvents.MOSUpdate, ({ videoScoresLog, audioScoresLog }) => {
                if (downgradeCallStateService.wasNotifiedAboutImprove())
                    return;
                if (activeVideoProvider.isInGroupCall)
                    return;
                if (downgradeCallStateService.wasDowngraded()) {
                    if (isGoodAudio(audioScoresLog, {
                        consecutiveItemsCount: 20,
                        scoreMoreThan: 3,
                        afterTimestamp: downgradeTimestamp,
                    })) {
                        downgradeCallStateService.connectionImproved();
                        pn.people.models.forEach((otherPerson) => {
                            this.notifyAboutImprove(otherPerson);
                        });
                    }
                }
                else {
                    if (isPoorVideo(videoScoresLog, {
                        consecutiveItemsCount: 15,
                        scoreLessThan: 1.5,
                        frameRateLessThan: 3,
                    })) {
                        downgradeTimestamp = Date.now();
                        downgradeCallStateService.downgradeToAudioOnly({
                            currentPersonIsCulprit: false,
                        });
                        pn.people.models.forEach((otherPerson) => {
                            this.downgradeToAudioCall(otherPerson);
                        });
                    }
                }
            });
        }
        activeVideoProvider.on(VideoProviderEvents.ConnectionDestroyed, (connection, reason) => {
            const username = connection.userName;
            if (shouldStopVideo()) {
                this.stop();
                // Just need to notify patient and doctor why they have been dropped from the call
                // In this case we handle only networkDisconnected reason
                const amIDoctor = pn.isDoctor();
                if (reason === 'networkDisconnected') {
                    if (amIDoctor) {
                        $rootScope.$emit('activeProvider:endReason', EndCallReasons.PATIENT_NETWORK);
                        // For doctor just notification for now
                        return notificationFactory.showCommon('warning', 'call.dropped.patient-disconnected.network-problem');
                    }
                    else {
                        // It will be handled by video-chat-dropped-screen notification
                        $rootScope.$emit('patient:stop:doctorNetworkDisconnected');
                        $rootScope.$emit('activeProvider:endReason', EndCallReasons.DOCTOR_NETWORK);
                    }
                }
                else {
                    // eslint-disable-next-line no-lonely-if
                    if (amIDoctor) {
                        $rootScope.$emit('activeProvider:endReason', EndCallReasons.PATIENT_LEFT);
                        if (hasGrowthBookFeature(GrowthBookFeatures.Voyce) &&
                            connection.person.state.pid === 'voyce') {
                            return notificationFactory.showCommon('warning', 'call.patient-disconnected.interpreter-disconnected', null, notificationConstants.HIDE_DELAY_BY_END_CALL);
                        }
                        return notificationFactory.showCommon('warning', 'call.patient-disconnected.client-disconnected{{username}}', null, notificationConstants.HIDE_DELAY_BY_END_CALL, {
                            username,
                        });
                    }
                    else {
                        $rootScope.$emit('activeProvider:endReason', EndCallReasons.DOCTOR_LEFT);
                    }
                }
            }
            else {
                // when someone dropped from the call we have to notify with a reason
                let message;
                const amIDoctor = pn.isDoctor();
                if (reason === 'networkDisconnected') {
                    if (amIDoctor) {
                        message =
                            'call.doctor.patient-disconnected.network-problem{{username}}';
                    }
                    else {
                        message =
                            'call.patient.patient-disconnected.network-problem{{username}}';
                    }
                }
                else {
                    message =
                        'call.patient-disconnected.client-disconnected{{username}}';
                }
                if (!globalUi.ui.isRestartingCall) {
                    // Don't show notification on call restart
                    notificationFactory.showCommon('warning', message, null, notificationConstants.HIDE_DELAY_BY_END_CALL, {
                        username,
                    });
                }
            }
            notificationFactory.playSound('end-call');
            $rootScope.$applyAsync();
        });
        activeVideoProvider.on(VideoProviderEvents.StreamCreated, () => {
            ensureMediaOptionsApplied(this.options);
            lastCallConfig = null;
        });
        activeVideoProvider.on(VideoProviderEvents.StreamDestroyed, (stream) => {
            $rootScope.$emit('phone:leave', stream.personConnection.person);
            if (stream.type === 'camera')
                stream.personConnection.person.endVideo();
            $rootScope.$applyAsync();
        });
        activeVideoProvider.on(VideoProviderEvents.Exception, ({ level, message, reason }) => {
            // errors with network problems we will handle with video-chat-dropped-screen
            // designed only for desktop now
            if (level === 'error' &&
                message === 'connection-failed' &&
                !Browser.isMobile) {
                const participants = _.clone(activeVideoProvider.peopleCollection.models);
                $rootScope.$emit('activeProvider:endReason', EndCallReasons.NETWORK_EXCEPTION);
                $rootScope.$emit('activeProvider:errorLevelExeption', reason);
                this.stop();
                $rootScope.$emit('activeProvider:stopBecauseOfNetworkError', {
                    participants,
                });
                return;
            }
            notificationFactory.showCommon(level, message);
            if (level === 'error') {
                $rootScope.$emit('activeProvider:errorLevelExeption', reason);
                $rootScope.$emit('activeProvider:endReason', EndCallReasons.EXCEPTION);
                this.stop();
            }
        });
        activeVideoProvider.on(VideoProviderEvents.SessionDisconnected, ({ reason }) => {
            pn.people.models.forEach((person) => person.endVideo());
            notificationFactory.playSound('end-call');
            // for now, ignore any other reasons
            if (reason === 'networkDisconnected') {
                // to remove loader screen after session dropped
                $rootScope.$emit('activeProvider:endReason', EndCallReasons.NETWORK_DISCONNECTED);
                globalUi.endCall();
                // to update state for everybody
                const updatedState = {
                    status: 'available',
                };
                if (pn.isPatient()) {
                    updatedState.callInitiator = null;
                }
                pn.setState(updatedState);
                $rootScope.$applyAsync();
            }
        });
    }
    let providerToUseAfterCallEnd = null;
    let providerToUseAfterCallEndPromise = null;
    let lastCallConfig = null;
    async function maybeChangeProvider(person) {
        $timeout.cancel(providerToUseAfterCallEndPromise);
        const activeProviderSlug = VideoProviderFactory.activeProviderName;
        if (person.isOnMobileApp() ||
            !person.isUsingVideoProvider(activeProviderSlug)) {
            providerToUseAfterCallEnd = activeProviderSlug;
            await VideoProviderFactory.switchTo('tokbox');
        }
    }
    function ensureMediaOptionsApplied(options) {
        const OTSession = VideoProviderFactory.activeProvider.OTSession;
        options = options || {};
        if (options.audioOnly) {
            /**
              @description Fix audio only for Android devices
              @issue https://doxyme.atlassian.net/browse/CS-1320
              @STR
                Start Audio only 1 to 1 call
                Put patient on hold
                Start 1 to 1 call (with video)
                Actual result: Patient miniature is black. Video is not displayed
                Expected result: Miniature shows photo. Video is displayed
              @todo: find the reason and fix in a good way
              */
            OTSession.togglePublishersVideo(true);
            OTSession.togglePublishersVideo(false);
        }
        if (options.applyLastConfig && lastCallConfig) {
            OTSession.togglePublishersVideo(lastCallConfig.hasVideo);
            OTSession.togglePublishersAudio(lastCallConfig.hasAudio);
        }
    }
    function trackWaitTime(videoChat, person) {
        CallSession.sessionParticipants
            .create({
            id: VideoProviderFactory.activeProvider.getCallSessionId(),
        }, {
            userId: Number(pn.getUserId()),
            participantUuid: person.uuid,
            waitTime: new Date().getTime() -
                person.state.checkedInAt +
                currentUserHelper.getServerTimeOffset(),
        })
            .$promise.then(() => {
            person.waitTimeSaved = true;
        });
    }
    return stampit({
        props: {
            room: null,
            isRestartingCall: false,
        },
        deepProps: {
            componentName: 'phone',
            active: false,
            peopleCollection: null,
            roomId: null,
            startedAt: null,
            events: {
                turnOffAudio: 'onTurnOffAudio',
            },
        },
        methods: {
            async start({ person, mediaMode, mainSessionId }) {
                const patientsAlreadyInCallWith = pn.people.find((p) => p.state.callInitiator === pn.getUserId() &&
                    p.state.status === 'video');
                if (VideoProviderFactory.activeProvider.audioType ===
                    AudioTypes.MEDICAL) {
                    mediaMode = MediaModes.ROUTED;
                }
                person.startVideo();
                globalUi.startCall();
                this.send(person.uuid, VideoChatRealtimeMessageTypes.INIT, {
                    options: this.options,
                });
                this.roomId = person.roomId;
                this.active = true;
                const isParallel = patientsAlreadyInCallWith.length > 0;
                ensureMediaOptionsApplied(this.options);
                try {
                    await maybeChangeProvider(person);
                    const { sessionId, channel, apiKey, joinTokens } = await VideoProviderFactory.activeProvider.startSession({
                        person,
                        roomId: this.roomId,
                        onSessionInit: _setStateOnVideoStart.bind(this),
                        mediaMode,
                        mainSessionId,
                        ipWhiteList: this.options.ipWhiteList,
                    });
                    $rootScope.$emit('phone:started', this.options);
                    ensureMediaOptionsApplied(this.options);
                    const { location } = selectLocationDetails($ngRedux.getState()) || {};
                    const { city, country_name: country, region_name: region, latitude, longitude, isp: serviceProvider, } = location || {};
                    const data = {
                        audioOnly: !!this.options.audioOnly,
                        mediaMode: undefined,
                        sessionId,
                        channel,
                        personUuid: person.uuid,
                        isParallel,
                        hasVideo: VideoProviderFactory.activeProvider.ui.hasVideo,
                        hasAudio: VideoProviderFactory.activeProvider.ui.hasAudio,
                        noSoundDetected: undefined,
                        city,
                        country,
                        region,
                        latitude,
                        longitude,
                        serviceProvider,
                        patientQueueCount: pn.people.getPatients().length,
                    };
                    $rootScope.$emit(RootScopeEvents.PHONE.START, data);
                    this.invitePerson({
                        person,
                        channel,
                        sessionId,
                        mediaMode,
                        apiKey,
                        joinToken: joinTokens?.find((joinToken) => joinToken.identityId === person.uuid)?.token,
                    });
                    pn.setState({
                        status: 'video',
                        videoStartedAt: new Date().getTime(),
                    });
                    this.republishScreenShare();
                    // this.person.state.videoStartedAt can be undefined if patient
                    // is on mobile app or has stale version of code
                    // we can use time when call has been started
                    // on doctor's side instead (which would be +/- precise)
                    this.startedAt = new Date().getTime();
                    const { platform, os, browser, browserVersion } = Browser.getSystemInfo();
                    // eslint-disable-next-line
                    const participant_count = _.get(VideoProviderFactory, 'activeProvider.peopleCollection.length');
                }
                catch (e) {
                    person.endVideo();
                    $log.error('phone.start', e);
                    globalUi.set({
                        video: false,
                        videoEndedAt: new Date().getTime(),
                    });
                }
                globalUi.ui.isRestartingCall = false;
            },
            invitePerson({ person, channel, sessionId, mediaMode, apiKey, joinToken, }) {
                person.startVideo();
                this.sendInvite({
                    person,
                    sessionId,
                    channel,
                    mediaMode,
                    apiKey,
                    joinToken,
                });
            },
            onTurnOffAudio(data, person) {
                $timeout(() => {
                    VideoProviderFactory.activeProvider.OTSession.togglePublishersAudio(false);
                    $rootScope.$emit('onTurnOffAudioByPerson', person);
                });
            },
            async join({ message, person }) {
                globalUi.startCall();
                const { channel, sessionId, mediaMode, apiKey, roomId, joinToken } = message;
                this.active = true;
                ensureMediaOptionsApplied(this.options);
                try {
                    await maybeChangeProvider(person);
                    await VideoProviderFactory.activeProvider.joinSession({
                        joinToken,
                        channel,
                        person,
                        sessionId,
                        mediaMode,
                        apiKey,
                        roomId,
                        onSessionInit: _setStateOnVideoStart.bind(this),
                        ipWhiteList: this.options.ipWhiteList,
                    });
                    $rootScope.$emit('phone:started', this.options);
                    ensureMediaOptionsApplied(this.options);
                    const { location } = selectLocationDetails($ngRedux.getState()) || {};
                    const { city, country_name: country, region_name: region, latitude, longitude, isp: serviceProvider, } = location || {};
                    const data = {
                        audioOnly: !!this.options.audioOnly,
                        mediaMode: undefined,
                        sessionId,
                        channel,
                        personUuid: person.uuid,
                        hasVideo: VideoProviderFactory.activeProvider.ui.hasVideo,
                        hasAudio: VideoProviderFactory.activeProvider.ui.hasAudio,
                        noSoundDetected: undefined,
                        isParallel: null,
                        callInitiator: person.getUserId(),
                        city,
                        country,
                        region,
                        latitude,
                        longitude,
                        serviceProvider,
                        doctorQueueCount: pn.people.getDoctors().length,
                    };
                    $rootScope.$emit(RootScopeEvents.PHONE.START, data);
                    pn.setState({
                        status: 'video',
                        videoStartedAt: new Date().getTime(),
                        callInitiator: person.getUserId(),
                        callInitName: person.state.username,
                    });
                    this.republishScreenShare();
                }
                catch (e) {
                    $log.error('join', e);
                    globalUi.set({
                        video: false,
                        videoEndedAt: new Date().getTime(),
                    });
                }
                globalUi.ui.isRestartingCall = false;
            },
            republishScreenShare() {
                const OTSession = VideoProviderFactory.activeProvider.OTSession;
                if (OTSession.screensharePublisher &&
                    globalUi.ui.isRestartingCall) {
                    OTSession.session.publish(OTSession.screensharePublisher);
                }
            },
            endVideo({ notification }) {
                VideoProviderFactory.activeProvider.peopleCollection.models.forEach((person) => {
                    person.endVideo();
                    if (notification) {
                        this.send(person.uuid, 'end', {
                            notification,
                        });
                    }
                });
                this.stop(notification === CallNotifications.Hold);
            },
            requestVideoRestart(notification, loaderMessage) {
                this.isRestartingCall = true;
                const requests = VideoProviderFactory.activeProvider.peopleCollection.map((person) => this.send(person.uuid, 'restart', {
                    notification,
                    loaderMessage,
                }));
                return Promise.all(requests).then(() => this.stop());
            },
            turnOffParticipantAudio(person) {
                const channel = VideoProviderFactory.activeProvider.getSessionId();
                const sessionId = VideoProviderFactory.activeProvider.getCallSessionId();
                return this.send(person.uuid, 'turnOffAudio', {
                    sessionId,
                    channel,
                    options: this.options,
                });
            },
            turnOffParticipantAudioByUuid(uuid) {
                const person = pn.allJoinedPeople.findByUid(uuid);
                this.turnOffParticipantAudio(person);
            },
            downgradeToAudioCall(person) {
                const channel = VideoProviderFactory.activeProvider.getSessionId();
                const sessionId = VideoProviderFactory.activeProvider.getCallSessionId();
                this.send(person.uuid, 'downgradeToAudio', {
                    sessionId,
                    channel,
                    options: this.options,
                });
            },
            notifyAboutImprove(person) {
                const channel = VideoProviderFactory.activeProvider.getSessionId();
                const sessionId = VideoProviderFactory.activeProvider.getCallSessionId();
                this.send(person.uuid, 'connectionImproved', {
                    sessionId,
                    channel,
                    options: this.options,
                });
            },
            sendInvite({ person, sessionId, channel, mediaMode, apiKey, joinToken, }) {
                channel =
                    channel || VideoProviderFactory.activeProvider.getSessionId();
                sessionId =
                    sessionId ||
                        VideoProviderFactory.activeProvider.getCallSessionId();
                mediaMode =
                    mediaMode || VideoProviderFactory.activeProvider.getMediaMode();
                const apiKeyValue = Boolean(apiKey)
                    ? apiKey
                    : VideoProviderFactory.activeProvider.getApiKey();
                return this.send(person.uuid, 'start', {
                    joinToken,
                    sessionId,
                    channel,
                    mediaMode,
                    apiKey: apiKeyValue,
                    roomId: this.roomId,
                    audioType: VideoProviderFactory.activeProvider.audioType,
                    options: this.options,
                });
            },
            stop(isHold = false) {
                debug('STOP');
                if (!lastCallConfig) {
                    lastCallConfig = Object.assign({}, VideoProviderFactory.activeProvider.ui);
                }
                // eslint-disable-next-line
                const participant_count = _.get(VideoProviderFactory, 'activeProvider.peopleCollection.length');
                VideoProviderFactory.activeProvider.endSession();
                const amIDoctor = pn.isDoctor();
                globalUi.set({
                    pinnedStreamId: null,
                });
                if (!this.active)
                    return;
                this.active = false;
                const updatedState = {
                    status: 'available',
                };
                if (pn.isPatient()) {
                    updatedState.callInitiator = null;
                }
                pn.setState(updatedState);
                globalUi.set({
                    video: false,
                });
                if (providerToUseAfterCallEnd) {
                    providerToUseAfterCallEndPromise = $timeout(() => {
                        VideoProviderFactory.switchTo(providerToUseAfterCallEnd);
                        providerToUseAfterCallEnd = null;
                    }, 30000);
                }
                if (!this.isRestartingCall) {
                    globalUi.set({
                        sidebarHidden: false,
                    });
                    VideoProviderFactory.activeProvider.changeAudioType(AudioTypes.STANDARD);
                    $rootScope.$emit('video-chat-loading-screen:update-message', 'session.ending');
                    if (amIDoctor && !isHold) {
                        const { providerSurveyId, providerSurveyFrequency, isDokbotExtensionInstalled, } = dokbot.selectors.getWorkflow($ngRedux.getState());
                        if (isDokbotExtensionInstalled && providerSurveyId) {
                            dokbot.initialiser.launchDelayedOneIn(providerSurveyFrequency);
                        }
                        else {
                            callQualitySurveyService.showDelayedOneIn(10);
                        }
                    }
                    lastCallConfig = null;
                }
                $rootScope.$emit('phone:end');
            },
            forceDisconnect(target) {
                target.endVideo();
                this.send(target.uuid, 'forceDisconnect');
            },
        },
    }).compose(RealtimeComponent);
}).name;
